import {
  type OutdoorSection,
  type OutdoorSectionRevenueRow,
} from '@pigello/pigello-matrix';
import { createBaseRentHandler } from './shared-base-rent-handler';

// Custom handler for outdoor section to include revenue rows
export const handleCustomOutdoorSectionNestedCase = createBaseRentHandler<
  OutdoorSection,
  OutdoorSectionRevenueRow
>('outdoorsectionrevenuerow');
